module.exports = __webpack_public_path__ + "img/lamina1-secondary.08530d49.png";